<template>
  <path
    d="M12 3.00018C7.41001 3.00018 3.86001 4.53018 0.89001 6.59018C0.40001 6.92018 0.30001 7.59018 0.67001 8.05018L10.45 20.0902C11.25 21.0702 12.75 21.0802 13.55 20.0902L23.33 8.07018C23.7 7.61018 23.6 6.94018 23.11 6.61018C20.14 4.54018 16.59 3.00018 12 3.00018ZM12 16.0002C11.45 16.0002 11 15.5502 11 15.0002V11.0002C11 10.4502 11.45 10.0002 12 10.0002C12.55 10.0002 13 10.4502 13 11.0002V15.0002C13 15.5502 12.55 16.0002 12 16.0002ZM11 8.00018V6.00018H13V8.00018H11Z"
  />
</template>
